<div class="flex-1 flex flex-col gap-2">
  <!-- Grower Dashboard h-[49%]-->
  <div class="flex-[49] flex flex-row gap-2.5">
    <!-- Grower Map -->
    <div class="flex-1 shadow-md rounded-lg overflow-clip">
      <!-- geom: input is the claimedFieldsForMap, including id, field_id and geom mode: input is the mode from the themeService -->
      <app-dashboard-map
        [geom]="claimedFieldsForMap"
        [mode]="mode"
        [type]="'grower'"
      >
      </app-dashboard-map>
    </div>
    <!-- Grower Table h-full -->
    <div class="overflow-auto flex-[2] shadow-md rounded-lg">
      <app-dashboard-table
        [allClaimedFields]="claimedFields ?? []"
        [columnLabels]="{
          field_name: 'Field Name',
          field_id: 'Land IQ Field ID',
          entities: 'Entities',
          total_target_water: 'Target Water',
          is_deficit_irrigation: 'Deficit Irrigation',
          crop_type_01: 'Crop 1',
          crop_type_02: 'Crop 2',
          crop_type_03: 'Crop 3',
          county: 'County',
        }"
        [columnVisibility]="{
          field_name: true,
          field_id: true,
          entities: true,
          total_target_water: true,
          is_deficit_irrigation: false,
          crop_type_01: true,
          crop_type_02: false,
          crop_type_03: false,
          county: false,
        }"
      />
    </div>
  </div>

  <!-- h-[50%] -->
  <div class="flex-[51] shadow-lg rounded-lg">
    <app-dashboard-chart
      [type]="'grower'"
      [claimedFieldsForChart]="claimedFields"
    ></app-dashboard-chart>
  </div>
</div>
